import { Component, OnInit, OnDestroy } from '@angular/core';
import { MasterActions, GridHeader, Tags, defaultTags, GridHeaderEx } from 'src/app/model';
import { Subscription } from 'rxjs';
import { MsgService, TagsService, UtilService,UserType } from 'src/app/service';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss']
})
export class TagsComponent implements OnInit, OnDestroy, MasterActions {
  private subscription = new Subscription();
  public cols: Array<GridHeader> = [];
  public dataArray: Array<Tags>;
  public selectedRows: Array<any> = [];
  public selectedColumns: Array<GridHeader>;
  public dataObj: Tags = defaultTags;
  public isDeleteDetails = false;
  public isAddDetails = false;
  public isEditDetails = false;
  public isViewDetails = false;
  public editCallTypeList: any = {};
  public tagsList: Array<SelectItem> = [];
  public selectedTags: any;
  
  public set isEditShow(value: boolean) {
    this.isEditDetails = value;
    this.isAddDetails = value;
  }

  public get isEditShow() {
    return this.isEditDetails || this.isAddDetails;
  }

  public get dlgHeader() {
    return (this.isViewDetails ? 'View ' : (this.isEditDetails ? 'Edit ' : 'Add ')) + this.pageName;
  }

  /** grid columns and data fields */
  private columnsConfig: Array<GridHeaderEx> = [
    { field: 's_no', header: 'S No', isVisible: true, isDefault: true },
    { field: 'tag_id', header: 'Id', isVisible: false, isDefault: true },
    { field: 'parent_name', header: 'Parent Tag', isVisible: true, isDefault: true },
    { field: 'tag_name', header: 'Tags Name', isVisible: true, isDefault: true },
    { field: 'status', header: 'Actions', isVisible: true, isDefault: true },
  ];

  public get pageName() {
    return this.dataService.pageName;
  }
  public get isCreator() {
    return this.util.getUserRole === UserType.Creator;
  }
  constructor(
    private msgSvc: MsgService,
    public util: UtilService,
    private dataService: TagsService
  ) { }

  ngOnInit() {
    this.cols = this.columnsConfig.filter(i => i.isVisible)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });

    this.selectedColumns = this.columnsConfig.filter(i => i.isVisible && i.isDefault)
      .map((e: GridHeaderEx) => {
        return { field: e.field, header: e.header };
      });
    this.dataService.getDataRecords();
    this.subscription.add(
      this.dataService.dataList.subscribe((data) => {
        this.dataArray = [];
        if (data.length) {
          this.dataArray = data.map((e, indx) => {
            e.s_no = indx + 1;
            return e;
          });
        } else {
          this.msgSvc.addInfoMsg({ summary: this.pageName, detail: 'No data exit' });
        }
      }));
      this.dataService.gettags()
      .subscribe(data => {
        this.tagsList = data.map(ele => {
          return { label: ele.tag_name, value: ele };
        });
      });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public editData(event) {
    this.dataObj = Object.assign({}, event ? event : defaultTags);
    if (event == null) {
      this.isAddDetails = true;
    } else {
      this.isEditDetails = true;
      this.bindDropDownList();
    }
  }
  private bindDropDownList() {

    if (this.dataObj.tag_id) {
      const item = this.tagsList
        // tslint:disable-next-line: triple-equals
        .find(e => e.value.tag_id == this.dataObj.parent_id);
        console.log(this.dataObj.parent_id);
        console.log(this.dataObj.tag_id);
      this.selectedTags = item ? item.value : undefined;
    }
    
  }

  public ontagsChange(event) {
    console.log(event);
    this.dataObj.parent_id = (event.value as Tags).tag_id;
   // this.dataObj.parent_name = (event.value as Tags).parent_name;
  }
  public updateData() {
    if (this.isAddDetails) {
      this.createDetails();
    } else {
      this.updateCallType();
    }
  }

  public createDetails() {
    this.dataService.addData(this.dataObj).subscribe((data) => {
      if (data) {
        this.dataService.getDataRecords();
      }
    }, err => {
      this.msgSvc.addErrorMsg(err);
    });
    this.isAddDetails = false;
  }

  public cancelEditDlg() {
    this.isViewDetails = false;
    this.isAddDetails = false;
    this.isEditDetails = false;
  }

  public updateCallType() {
    this.dataService.updateData(this.dataObj).subscribe((data) => {
      this.dataService.getDataRecords();
    });
    this.isEditDetails = false;
  }
 
  public deleteDetails() {
    this.dataService.deleteData(this.dataObj.tag_id).subscribe((data) => {
      this.dataService.getDataRecords();
    });
    this.isDeleteDetails = false;
  }

  public deleteData(obj: Tags) {
    this.dataObj = obj;
    this.isDeleteDetails = true;
  }

  public viewData(obj: Tags) {
    this.dataObj = obj;
    this.isViewDetails = true;
  }

  public updateStatus(obj: Tags) {
    this.dataService.updateStatus(obj);
  }
}
